import React from 'react';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import UnderConstructionPage from 'src/pages/UnderConstructionPage/UnderConstructionPage';

function MarketplacePage(): FunctionComponentReturnType {
    return <UnderConstructionPage/>;
}

export default MarketplacePage;
